import { default as deactivate } from "./deactivate.json";
import { default as reasons } from "./reasons.json";

const data = {
  deactivate,
  reasons,
};

const deactivation = {
  getReasons: () => data["reasons"],
  post: () => data["deactivate"],
};

export default deactivation;
